import type { SearchLocation } from '#/modules/search/types/SearchLocation';

export type MovementPageFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  location: SearchLocation | null;
  aboutYourself: string;
  phone: string;
  linkedinUrl: string;
  recaptchaKey: number;
  gRecaptchaResponse: unknown;
};

export type MovementPageRedirectState = {
  type: 'movement-page-2nd-step';
  movementPageFormValues: MovementPageFormValues;
};

export function isMovementPageRedirectState(
  data: unknown,
): data is MovementPageRedirectState {
  return Boolean(
    data &&
    typeof data === 'object' &&
    'type' in data &&
    data.type === 'movement-page-2nd-step',
  );
}
